var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tariffs-small" },
    [
      _c("collapse-footered", {
        staticClass: "tariffs_tablet_list_item",
        scopedSlots: _vm._u([
          {
            key: "head",
            fn: function() {
              return [
                _c("div", { staticClass: "tariffs_tablet_list_item_caption" }, [
                  _c("h3", { staticClass: "uppercase ta-center" }, [
                    _c("b", [_vm._v("Base")])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "tariffs_tablet_content" },
                  _vm._l(_vm.base, function(item, i) {
                    return _c(
                      "div",
                      {
                        key: "base" + i,
                        staticClass: "tariffs_tablet_content__item"
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: { src: item.ico, alt: "", width: "40" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "tariffs_tablet-text" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.text) +
                                "\n            "
                            ),
                            item.extra
                              ? _c("v-question", {
                                  attrs: { content: item.extra, small: true }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c("div", { staticClass: "tariffs_tablet_footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button button-primary button-sm",
                      on: {
                        click: function($event) {
                          return _vm.$emit("callback")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.translates.btn) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("collapse-footered", {
        staticClass: "tariffs_tablet_list_item",
        scopedSlots: _vm._u([
          {
            key: "head",
            fn: function() {
              return [
                _c("div", { staticClass: "tariffs_tablet_list_item_caption" }, [
                  _c("h3", { staticClass: "uppercase ta-center" }, [
                    _c("b", [_vm._v("Optimum")])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c("p", { staticClass: "tariffs_tablet_content" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.translates.opt) + "\n        "
                  ),
                  _c("b", [_vm._v("Base")]),
                  _vm._v(
                    "\n        " + _vm._s(_vm.translates.opt2) + "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tariffs_tablet_content" },
                  _vm._l(_vm.standard, function(item, i) {
                    return _c(
                      "div",
                      {
                        key: "base" + i,
                        staticClass: "tariffs_tablet_content__item"
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: { src: item.ico, alt: "", width: "40" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "tariffs_tablet-text" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.text) +
                                "\n            "
                            ),
                            item.extra
                              ? _c("v-question", {
                                  attrs: { content: item.extra, small: true }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c("div", { staticClass: "tariffs_tablet_footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button button-primary button-sm",
                      on: {
                        click: function($event) {
                          return _vm.$emit("callback")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.translates.btn) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("collapse-footered", {
        staticClass: "tariffs_tablet_list_item",
        scopedSlots: _vm._u([
          {
            key: "head",
            fn: function() {
              return [
                _c("div", { staticClass: "tariffs_tablet_list_item_caption" }, [
                  _c("h3", { staticClass: "uppercase ta-center" }, [
                    _c("b", [_vm._v("Smart")])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "content",
            fn: function() {
              return [
                _c("p", { staticClass: "tariffs_tablet_content" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.translates.opt) + "\n        "
                  ),
                  _c("b", [_vm._v("Optimum")]),
                  _vm._v(
                    "\n        " + _vm._s(_vm.translates.opt2) + "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tariffs_tablet_content" },
                  _vm._l(_vm.premium, function(item, i) {
                    return _c(
                      "div",
                      {
                        key: "base" + i,
                        staticClass: "tariffs_tablet_content__item"
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: { src: item.ico, alt: "", width: "40" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "tariffs_tablet-text" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.text) +
                                "\n            "
                            ),
                            item.extra
                              ? _c("v-question", {
                                  attrs: { content: item.extra, small: true }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c("div", { staticClass: "tariffs_tablet_footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button button-primary button-sm",
                      on: {
                        click: function($event) {
                          return _vm.$emit("callback")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.translates.btn) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }